import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: people_schema.FieldOption.
export default class FieldOption extends Fragment {
  declare [Type]: 'people-schema/field-option';

  // value is what actually gets stored in the database if this option is selected.
  @attr('string', { defaultValue: '' })
  declare value: string;

  // label is a human-friendly label for this option.
  @attr('string', { defaultValue: '' })
  declare label: string;

  // valueInt is used for storing numeric values in the database
  @attr('number', { defaultValue: 0 })
  declare valueInt: number;
}
